import { createFileRoute } from "@tanstack/react-router";
import { OnboardingPage } from "@/pages/OnboardingPage";

export const Route = createFileRoute("/onboarding")({
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    forceOnboarding?: string;
    fromDashboard?: string;
    previousWorkspaceId?: string;
  } => {
    const next: {
      forceOnboarding?: string;
      fromDashboard?: string;
      previousWorkspaceId?: string;
    } = {};
    if (typeof search.forceOnboarding === "string")
      next.forceOnboarding = search.forceOnboarding;
    if (typeof search.fromDashboard === "string")
      next.fromDashboard = search.fromDashboard;
    if (typeof search.previousWorkspaceId === "string")
      next.previousWorkspaceId = search.previousWorkspaceId;
    return next;
  },
  component: OnboardingPage,
});
